module.exports = __webpack_public_path__ + "static/media/photo6.848529fb.jpg";